import { useState } from 'react';
import './Login.css';
import { useNavigate } from 'react-router-dom';

export default function Login() {

  const navigate = useNavigate();

  const [userName, setUser] = useState('');
  const [password, setPassword] = useState('');

  function setLogin(e){
    e.preventDefault();
    if(userName === '9876543210'&& password==='123456'){
      navigate('/dash')
    }else{
      alert("Wrong Credentials");
    }
  }

  return (
    <>
<div class="sbody">

    <div class="main-container">
        <div class="bg-blur"></div>
        
        <div class="login-box">
            <div class="form-header">
                <div class="app-logo">
                    <i class="fas fa-shield-alt"></i>
                </div>
                <h1>Welcome Back</h1>
                <p>Login to manage your account</p>
            </div>

            <form onSubmit={setLogin}>
                <div class="input-group">
                    <label>Email Address</label>
                    <div class="field">
                        <i class="far fa-envelope"></i>
                        <input type="text" placeholder="sagar@example.com" value={userName} onChange={(e)=>{setUser(e.target.value)}}></input>
                    </div>
                </div>

                <div class="input-group">
                    <label>Password</label>
                    <div class="field">
                        <i class="fas fa-lock"></i>
                        <input type="password" placeholder="••••••••" value={password} onChange={(e)=>{setPassword(e.target.value)}}></input>
                    </div>
                </div>

                <div class="row">
                    {/* <label class="remember-me">
                        <input type="checkbox">
                        <span class="custom-check"></span>
                        Remember me
                    </label> */}
                    <a href="#" class="forgot-link">Forgot?</a>
                </div>

                <button type='submit' class="main-btn">
                    <span>Sign In</span>
                    <i class="fas fa-chevron-right"></i>
                </button>
            </form>

            <p class="bottom-msg">New member? <a href="#">Register Now</a></p>
        </div>
    </div>

</div>


    </>
  )
}